import React from 'react';
import SupportPromptGroup from '@amzn/awsui-chat-components-console/support-prompt-group';
import Box from '@amzn/awsui-components-console/box';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import { SnowmanIcon } from './SnowmanIcon';
import { ASSISTANT_DISPLAY_NAME, WELCOME_SUBTITLE } from './constants';

export interface WelcomeCardProps {
	onSuggestionClick: (text: string) => void;
	suggestions: string[];
}

const containerStyle: React.CSSProperties = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: '32px 24px',
	flex: 1,
};

export const WelcomeCard: React.FC<WelcomeCardProps> = ({ onSuggestionClick, suggestions }) => {
	const promptItems = suggestions.map((text) => ({
		text,
		id: text,
	}));

	return (
		<div style={containerStyle}>
			<SpaceBetween size="l" direction="vertical" alignItems="center">
				<div className="welcome-icon-entrance">
					<SnowmanIcon size={68} />
				</div>
				<div className="welcome-text-entrance">
					<Box variant="h2" textAlign="center">
						{`Hi, I'm ${ASSISTANT_DISPLAY_NAME}`}
					</Box>
				</div>
				<div className="welcome-text-entrance" style={{ animationDelay: '0.15s' }}>
					<Box variant="p" textAlign="center" color="text-body-secondary">
						{WELCOME_SUBTITLE}
					</Box>
				</div>
				<div className="welcome-prompts-entrance">
					<SupportPromptGroup
						ariaLabel="Suggested prompts"
						onItemClick={({ detail }) => onSuggestionClick(detail.id)}
						items={promptItems}
					/>
				</div>
			</SpaceBetween>
		</div>
	);
};
